import * as React from 'react';
import { Routes, Route } from 'react-router-dom';

import ArchivedManualProvider from './context';
import ManualHistoryPage from './ManualHistoryPage';
import ArchivedManualsVersions from './Versions';
import LegacyArchivedManualsProvider from '../LegacyArchivedManuals/context';
import LegacyArchivedManualsVersions from '../LegacyArchivedManuals/Versions';

const ArchivedManuals: React.FC = () => {
  return (
    <ArchivedManualProvider>
      <Routes>
        <Route
          path='legacy/:id'
          element={
            <LegacyArchivedManualsProvider>
              <LegacyArchivedManualsVersions />
            </LegacyArchivedManualsProvider>
          }
        />
        <Route
          path=':id'
          element={<ArchivedManualsVersions />}
        />
        <Route
          path=''
          element={<ManualHistoryPage />}
        />
      </Routes>
    </ArchivedManualProvider>
  );
};

export default ArchivedManuals;
